import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=2645c601&scoped=true&"
import script from "./PageHeader.vue?vue&type=script&lang=js&"
export * from "./PageHeader.vue?vue&type=script&lang=js&"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=2645c601&prod&scoped=true&lang=css&"
import style1 from "./PageHeader.vue?vue&type=style&index=1&id=2645c601&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2645c601",
  null
  
)

export default component.exports